<div class="showFull">
    <img alt="load image failed" [src]="data" fxFlex="100%">
</div>